import { getIdToken } from '../../utils/tokenUtils';
import config from '../../config';
import { useEffect, useState } from 'react';

const callApi = async (code: string, error: string | null) => {
  const token = getIdToken();
  if (!token) {
    throw new Error('No authentication token available');
  }

  const headers = new Headers();
  headers.set("Authorization", `Bearer ${token}`);
  headers.set('Accept', 'application/json');
  headers.set('Content-Type', 'application/json');

  const response = await fetch(config.bullhorn.callbackUrl, {
    headers,
    method: 'POST',
    body: JSON.stringify({ code, error })
  });

  if (!response.ok) {
    throw new Error(`Callback failed: ${response.status} ${response.statusText}`);
  }
}

export const BullhornCallback = () => {
  const [result, setResult] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const urlParts = window.location.href.split('?');
    if (urlParts.length > 1) {
      let queryString = new URLSearchParams(urlParts[1]);
      const code = queryString.get('code');
      const error = queryString.get('error');
      if (code) {
        window.history.replaceState({}, document.title, "/connections/bullhorn/callback");
        callApi(code, error)
          .then(() => {
            setResult(true);
          })
          .catch(e => {
            console.error('Bullhorn callback error:', e);
            setResult(false);
          });
      }

    }
  }, []);

  if (result === true) {
    window.location.replace("/settings");
  }
  if (result === false) {
    return <>Error connecting to Bullhorn. Please try again.</>;
  }

  return <>Connecting...</>;
};

